"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var constants_1 = require("../config/constants");
var routes_1 = require("../config/routes");
var api_1 = require("../libs/api");
exports.getOrganization = function (token) {
    return api_1.default.get(routes_1.GET_ORGANIZATION, {
        headers: {
            "WIDGET-KEY": token,
        },
    }).then(function (data) { return ({
        organization: tslib_1.__assign(tslib_1.__assign({}, data["organization"]), { buckets: data["buckets"] }),
        translations: data["widget_translation"]
            ? data["widget_translation"]
            : constants_1.fallbackTranslations,
        brandColors: data["brand_colors"]
            ? data["brand_colors"]
            : constants_1.fallbackBrandColors,
    }); });
};
